import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { AdminReleaseWalletHoldRequest } from "@shopexperts/legacy-api";

interface ReleaseAdminWalletHoldInput {
  transactionId: number;
  organizationId?: number;
  body?: AdminReleaseWalletHoldRequest;
}

export function useReleaseAdminWalletHold() {
  const api = useApi();
  const toaster = useToaster();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["admin", "wallet", "releaseHold"],
    mutationFn: async ({ transactionId, body }: ReleaseAdminWalletHoldInput) => {
      return await api.admin.wallet.releaseHold({
        params: { transaction: transactionId },
        body,
      });
    },
    onSuccess: (_transaction, variables) => {
      toaster.create({ title: "Wallet hold released successfully", type: "success" });
      queryClient.invalidateQueries({ queryKey: ["admin", "wallet", "transactions"] });

      if (variables.organizationId) {
        queryClient.invalidateQueries({ queryKey: ["admin", "wallet", "organization", variables.organizationId] });
        queryClient.invalidateQueries({ queryKey: ["admin", "wallet", "organization", variables.organizationId, "level"] });
        queryClient.invalidateQueries({ queryKey: ["admin", "wallet", "organization", variables.organizationId, "transactions"] });
      }
    },
    onError: (error: Error) => {
      toaster.create({ title: `Failed to release wallet hold: ${error.message}`, type: "error" });
    },
  });
}
